module.exports = __webpack_public_path__ + "img/Rogue.4750a4a6.png";